<template>
  <div class="cangchu_ck">
    <div>
      <div class="headerSearch">
        <div class="sousuo">
          <el-form
            ref="search"
            style="display: flex"
            :model="searchForm"
            label-position="center"
            label-width="90px"
          >
            <el-form-item label="化学品:" style="">
              <el-input
                v-model="searchForm.hxpMc"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="仓库名称:">
              <el-select v-model="searchForm.ckId" filterable placeholder="请选择">
                <el-option
                  v-for="(item, index) in ckmcList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="出库日期:">
              <el-col :span="10">
                <el-date-picker
                  v-model="searchForm.beginTime"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                />
              </el-col>
              <el-col
                style="text-align: center"
                class="line"
                :span="3"
              >-</el-col>
              <el-col :span="10">
                <el-date-picker
                  v-model="searchForm.endTime"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                />
              </el-col>
            </el-form-item>
            <el-form-item label="状态:" label-width="50px">
              <el-select v-model="searchForm.zt" placeholder="请选择">
                <el-option
                  v-for="(item, index) in statusList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-button
              class="sousuoButton"
              icon="el-icon-search"
              round
              size="small"
              type="primary"
              @click="handleCurrentChange(1)"
            >搜索</el-button>
            <el-button
              class="resetbutton"
              icon="el-icon-refresh-right"
              @click="reset"
            >重置</el-button>
          </el-form>
        </div>
      </div>
      <div
        style="
          margin: auto;
          width: 95%;
          max-width: 1518px;
          background-color: white;
          padding-top: 40px;
          padding-bottom: 51px;
        "
      >
        <div class="tablemes">
          <el-table
            ref="cktable"
            v-loading="loading"
            :data="tableData"
            border
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
            :cell-style="cellStyle"
            :header-cell-class-name="cellClass"
            @select-all="dialogCheck"
            @select="dialogCheck"
          ><!-- :cell-style="cellStyle" -->
            <el-table-column>
              <template slot="header">
                <el-button
                  v-preventReClick
                  type="primary"
                  class="addButton"
                  size="mini"
                  style="border: none"
                  icon="el-icon-plus"
                  @click="addPupShow"
                >新增</el-button>
                <el-button
                  v-preventReClick
                  size="mini"
                  icon="el-icon-plus"
                  @click="copyAdd"
                >复制新增</el-button>
                <el-button
                  v-preventReClick
                  icon="el-icon-upload2"
                  size="mini"
                  @click="exportData"
                >导出</el-button>
              </template>
              <el-table-column
                align="center"
                type="selection"
                width="55"
              />

              <el-table-column
                v-for="(item, i) in table"
                :key="i"
                :show-overflow-tooltip="true"
                align="center"
                :label="item.label"
                :width="item.key == 'ckbh' ? '180' : ''"
              >
                <template slot-scope="scope">
                  <span
                    v-if="item.label == '变更次数'"
                    style="cursor: pointer"
                    :title="scope.row[item.key]"
                    @click="bgcsClick(scope.row)"
                  >
                    {{ scope.row[item.key] }}
                  </span>
                  <span
                    v-if="item.label !== '变更次数'"
                    :title="scope.row[item.key]"
                  >
                    {{ scope.row[item.key] }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="200px">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.zt != '00'"
                    type="primary"
                    icon="el-icon-document"
                    size="mini"
                    @click="lookItem(scope.row)"
                  >查看</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    type="primary"
                    icon="el-icon-edit"
                    size="mini"
                    @click="editItem(scope.row)"
                  >编辑</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    v-preventReClick
                    type="primary"
                    class="deleteButton"
                    icon="el-icon-delete"
                    size="mini"
                    @click="deleteItem(scope.row.id)"
                  >删除</el-button>
                  <el-button
                    v-if="scope.row.zt != '00'"
                    :disabled="scope.row.zt != '01'"
                    :type="scope.row.zt == '11' ? 'info' : 'warning'"
                    icon="el-icon-edit"
                    size="mini"
                    @click="changeItem(scope.row)"
                  >变更</el-button>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <el-pagination
            background
            layout="prev, pager,next,jumper,total,sizes"
            :page-sizes="[10, 20, 30, 40]"
            :total="total"
            :page-size="pagesize"
            class="el-page"
            @size-change="pagesizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <bgcs
      :bgwindow="bgwindow"
      :bgcs-t-k-name="bgcsTKName"
      @closeBindWarnStandard="handleCloseBindWarnStandard"
    />
    <cangchu-ck-pup
      ref="cangchuCk"
      :children-type="childrenType"
      :dis-label="disLabel"
      :djsjshow="djsjshow"
    />
  </div>
</template>
<script>
import CangchuCkPup from './cangchuCkPup.vue'
import {
  getCkxxList,
  getStatus,
  deleteDreft,
  exportData
} from '@/assets/js/ccgl.js'
import sCompanyData from '@/assets/js/pageDto.js'
import bgcs from '@/components/bgcs'
import {getListCkcx} from '@/assets/js/common.js'
import {isEmpty} from "@/utils/tool";
export default {
  components: { CangchuCkPup, bgcs },
  mixins: [sCompanyData],
  props: {},
  data() {
    return {
      bgcsTKName: '仓储出库',
      bgwindow: false, // 变更次数弹窗
      // 登记时间
      djsjshow: false,
      // 变更
      loading: true,
      activeRowId: '', // 当前选中数据id
      childrenType: '', // 子组件操作类型
      ckmcList: [], // 仓库名称list
      statusList: [], // 状态list
      pupopShow: false,
      disLabel: true,
      searchForm: {
        hxpMc: '',
        zt: '',
        ckId: '',
        beginTime: '',
        endTime: ''
      },
      table: [
        {
          key: 'ckbh',
          label: '出库编号'
        },
        {
          key: 'wtDwMc',
          label: '委托单位'
        },
        {
          key: 'hxpMc',
          label: '化学品名称'
        },
        {
          key: 'ckMc',
          label: '仓库名称'
        },
        {
          key: 'ckslStr',
          label: '出库数量'
        },
        {
          key: 'ckrq',
          label: '出库日期'
        },
        {
          key: 'djr',
          label: '登记人'
        },
        {
          key: 'djsj',
          label: '登记时间'
        },
        {
          key: 'bgcs',
          label: '变更次数'
        },
        {
          key: 'ztStr',
          label: '状态'
        }
      ],
      tableData: [], // 表格数据
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10 // 每页的数据条数
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.loadDataSource()
    this.loadLabel()
  },
  beforeDestroy() {},
  methods: {
    // 点击变更次数
    bgcsClick(curRow) {
      this.curRowObj = curRow
      this.$bus.emit('bgcsOpen', curRow, '11')
      this.bgwindow =
        curRow.bgcs > 0 ? (this.bgwindow = !this.bgwindow) : false
    },
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (columnIndex == 9) {
        switch (row.zt) {
          case '01':
            cellStyle = 'color:#6FC89A;font-weight:bold '
            break
          case '11':
            cellStyle = 'color:#43A5E2;font-weight:bold '
            break
          case '00':
            cellStyle = 'color:#000;font-weight:bold '
            break
          default:
            cellStyle = ''
            break
        }
        return cellStyle
      }
    },
    // 实现表格单选
    dialogCheck(selection, row) {
      this.$refs.cktable.clearSelection()
      this.activeRowId = ''
      if (selection.length === 0) {
        // 判断selection是否有值存在
        return
      }
      if (row) {
        this.selectioned = row
        this.$refs.cktable.toggleRowSelection(row, true)
        if (row.hasOwnProperty('id')) {
          this.activeRowId = row.id
        }
      }
    },
    // 取消全选按钮
    cellClass(row) {
      if (row.columnIndex === 0) {
        return 'disableheadselection'
      }
    },
    // 导出
    exportData() {
      exportData({
        param: this.searchForm,
        page: this.currentPage,
        size: this.pagesize
      }).then((e) => {
        const table = '仓储出库'
        const a = document.createElement('a')
        const blob = new Blob([e.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    // 重置
    reset() {
      this.searchForm = {
        hxpMc: '',
        zt: '',
        ckId: '',
        beginTime: '',
        endTime: ''
      }
      this.loadDataSource()
    },
    // 新增
    addPupShow() {
      this.childrenType = 'add'
      this.disLabel = false
      this.$refs.cangchuCk.dialogVisible = true
      this.djsjshow = false
      this.$refs.cangchuCk.biangengShow = false
      this.$refs.cangchuCk.loadLabel()
      setTimeout(() => {
        this.$refs.cangchuCk.initCon({}, 11)
      }, 30)
    },
    // 查看
    lookItem(val) {
      this.childrenType = 'look'
      this.$refs.cangchuCk.ckckForm = val
      this.disLabel = true
      this.$refs.cangchuCk.dialogVisible = true
      this.djsjshow = true
      this.$refs.cangchuCk.biangengShow = false
      setTimeout(() => {
        this.$refs.cangchuCk.initCon(val, 11)
      }, 30)
    },
    // 编辑
    editItem(val) {
      this.childrenType = 'edit'
      this.$refs.cangchuCk.ckckForm = val
      if(isEmpty(val.hxpBm)){
        this.$refs.cangchuCk.ckckForm.ckslDw = ''
      }
      this.disLabel = false
      this.$refs.cangchuCk.dialogVisible = true
      this.djsjshow = true
      this.$refs.cangchuCk.biangengShow = false

      setTimeout(() => {
        this.$refs.cangchuCk.initCon({}, 11)
      }, 30)
    },
    // 复制新增
    copyAdd() {
      this.djsjshow = false
      if (this.activeRowId === '') {
        this.$message({
          type: 'warning',
          message: '请选择一条记录'
        })
        return
      }
      this.childrenType = 'copy'
      this.tableData.filter((item, index) => {
        if (item.id === this.activeRowId) {
          this.$refs.cangchuCk.ckckForm = item
        }
      })
      this.disLabel = false
      this.$refs.cangchuCk.dialogVisible = true
      this.$refs.cangchuCk.biangengShow = false
      this.$refs.cangchuCk.loadLabel()

      setTimeout(() => {
        this.$refs.cangchuCk.initCon({}, 11)
      }, 30)
    },
    // 变更
    changeItem(row) {
      this.childrenType = 'change'
      this.$refs.cangchuCk.ckckForm = row
      this.$refs.cangchuCk.biangengShow = true
      this.disLabel = true
      this.$refs.cangchuCk.dialogVisible = true
      this.djsjshow = true

      setTimeout(() => {
        this.$refs.cangchuCk.initCon(row, 11)
      }, 30)
    },
    // 删除
    deleteItem(val) {
      this.$confirm('此操作将删除您的草稿, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteDreft(val)
          .then((e) => {
            if (e.data.code == '000000') {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              this.loadDataSource()
            }
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除操作'
            })
          })
      })
    },
    // 下拉选项加载
    loadLabel() {
      getListCkcx().then((e) => {
        this.ckmcList = e.data.data
      })
      getStatus().then((e) => {
        this.statusList = e.data.data
      })
    },
    // 数据加载
    loadDataSource() {
      getCkxxList({
        param: this.searchForm,
        page: this.currentPage,
        size: this.pagesize
      })
        .then((e) => {
          this.tableData = e.data.data.rows
          this.total = e.data.data.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    pagesizeChange(val) {
      this.pagesize = val
      this.loadDataSource()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadDataSource()
    }
  }
}
</script>
<style scoped lang="less">
.el-table--border {
  z-index: 0;
}
.resetbutton {
  width: 90px;
  height: 39px;
  border-radius: 20px;
}
.cangchu_ck {
  // height: 100%;
  // width: 90%;
  // background-color: white;
  // margin: auto;
  .headerSearch {
    max-width: 1518px;
    width: 95%;
    margin: auto;
    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        width: 90px;
        height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }
  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      border-color: #4170ff;
    }
    .chongzhiButton {
      width: 90px;
      height: 39px;
    }
  }
  .tablemes {
    margin: auto;
    width: 90%;
    max-width: 1375px;
    margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    .deleteButton {
      background: #ff5721 !important;
      border-color: #ff5721 !important;
    }
    .el-button--warning {
      color: #fff;
      background: #feb800;
      border-radius: 3px;
      border-color: #feb800;
    }
    .el-button--primary {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}

// 取消全选 样式
/deep/ .disableheadselection > .cell .el-checkbox__inner {
  display: none !important;
}
</style>
